import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ChatIcon from '@material-ui/icons/Chat';
import theme from '../../theme';

const useStyles = makeStyles((th) => ({
  supportButton: {
    backgroundColor: theme.colors.DodgerBlue,
    color: '#fff',
    borderRadius: '50px',
    padding: th.spacing(1.5, 3),
    boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease, display 1s ease-in-out',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0px 6px 15px rgba(0,0,0,0.3)',
      backgroundColor: theme.colors.DodgerBlueLight,
    },
    cursor: "pointer"
  },
}));

export default function SupportButton({ value = "Support", ...props }) {
  const classes = useStyles();

  const handleClick = () => {
    alert('Customer Support Coming Soon!');
  };

  return (
    <Button
      variant="contained"
      className={classes.supportButton}
      startIcon={<ChatIcon />}
      onClick={handleClick}
      {...props}
    >
      {value}
    </Button>
  );
}
